export const isFunction = fn => fn && {}.toString.call(fn) === "[object Function]";

export const isString = value => typeof value === "string" || value instanceof String;

export const isArray = value => Array.isArray(value);
